import { Tag } from 'antd'
import styled, { css } from 'styled-components'

const StyledAiHighlightedTag = styled(Tag)`
  ${props =>
    props.isSuggestedByAi &&
    css`
      border-color: #1890ff;
    `};
`

export default StyledAiHighlightedTag
